import { Const } from '../lib/const.cls'

export const mutations = {
	[Const.SET_CARD_USERS] (state, data) {									
		try {state.cardUsers = data} catch (ex) {console.debug('set state EX', ex)}
	},
	// [Const.SET_CARD_SUB_USERS] (state, data) {									
	// 	try {state.cardSubUsers = data} catch (ex) {console.debug('set state EX', ex)}
	// },


	[Const.SET_COUNTRIES_LIST] (state, data) {									
		try {state.countriesList = data} catch (ex) {console.debug('set state EX', ex)}
	},
	[Const.SET_CITIES_LIST] (state, data) {									
		try {state.citiesList = data} catch (ex) {console.debug('set state EX', ex)}
	},

	//fee-history
	[Const.SET_FEE_HISTORY] (state, data) {									
		try {
			state.feeHistory = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},

	//pricing
	[Const.SET_PRICING_PLAN_LIST] (state, data) {									
		try {
			state.pricingPlanList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_PRICING_PLAN_DETAIL] (state, data) {									
		try {
			state.pricingPlanDetail = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_PRICING_OFFER_LIST] (state, data) {									
		try {
			state.pricingOfferList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_PRICING_OFFER_DETAIL] (state, data) {									
		try {
			state.pricingOfferDetail = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	//roles
	[Const.SET_ALL_ROLES] (state, data) {									
		try {
			state.userAllRoles = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	//permission
	[Const.SET_PERMISSION_LIST] (state, data) {									
		try {
			state.permission = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	
	[Const.SET_EMAIL_DATA] (state, data) {									
		try {
			state.emailData = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	
	//email
	[Const.SET_EMAIL_SETTING_LIST] (state, data) {									
		try {
			state.emailList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	//coupon
	[Const.SET_COUPON_LIST] (state, data) {									
		try {
			state.couponList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_SUB_EXSIST_LIST] (state, data) {									
		try {
			state.subExistList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_SUB_PLAN_LIST] (state, data) {									
		try {
			state.sunPlanList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_SUB_PLAN_DETAIL] (state, data) {									
		try {
			state.subPlanDetail = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	//reporting
	[Const.SET_REPORTING_LIST] (state, data) {									
		try {
			state.reportingList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_EMIR_LIST] (state, data) {									
		try {
			state.emirList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	//admin
	[Const.SET_ADMIN_LIST] (state, data) {									
		try {
			state.adminList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_NOTIFICATION_LIST] (state, data) {									
		try {
			state.notificationList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_NOTIFICATION_READ_LIST] (state, data) {									
		try {
			state.notificationReadList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_NOTIFICATION_UNREAD_LIST] (state, data) {									
		try {
			state.notificationUnreadList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_LOGS_LIST] (state, data) {									
		try {
			state.logsList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_LOGS_VIEW] (state, data) {									
		try {
			state.logsView = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_ADMIN_DETAIL] (state, data) {									
		try {
			state.adminDetail = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	//client
	[Const.SET_USER_GROUP_ID] (state, data) {									
		try {
			state.userGroupId = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_GROUP_ADMIN_NAME] (state, data) {									
		try {
			state.groupAdminName = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_WITHDRAWAL_METHODS] (state, data) {									
		try {
			state.withdrawalMethods = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_WITHDRAWAL_METHOD_RESPONSE] (state, data) {									
		try {
			state.withdrawalMethodResponse = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_ARTICLE_LIST] (state, data) {									
		try {
			state.articleList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_CAT_LIST] (state, data) {									
		try {
			state.catList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_USER_LIST] (state, data) {									
		try {
			state.userList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_USER_VIEW] (state, data) {									
		try {
			state.userView = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_USER_COUNT] (state, data) {									
		try {
			state.userCount = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_INTERNAL_NOTES] (state, data) {									
		try {
			state.internalNotes = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_RISK_METRIX] (state, data) {									
		try {
			state.riskMetrix = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	
	//deposit
	[Const.SET_DEPOSIT_LIST]: (state, data) => {		
		try {
			state.depositList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_DEPOSIT_VIEW]: (state, data) => {		
		try {
			state.depositView = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	
	//bonus
	[Const.SET_BONUS_LIST]: (state, data) => {		
		try {
			state.bonusList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_BONUS_VIEW]: (state, data) => {		
		try {
			state.bonusView = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},

	//ticket
	[Const.SET_TICKET_LIST]: (state, data) => {		
		try {
			state.ticketList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_TICKET_REASON_LIST]: (state, data) => {		
		try {
			state.ticketReasonList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_TICKET_REASON_LIST2]: (state, data) => {		
		try {
			state.ticketReasonList2 = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_TICKET_VIEW]: (state, data) => {		
		try {
			state.ticketView = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_TICKET_DOCS]: (state, data) => {		
		try {
			state.ticketDocs = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	
	//withdrawal
	[Const.SET_WITHDRAWAL_LIST]: (state, data) => {	
		try {
			state.withdrawalList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_WITHDRAWAL_LIST_MAKER]: (state, data) => {	
		try {
			state.withdrawalListMaker = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_WITHDRAWAL_VIEW]: (state, data) => {	
		try {
			state.withdrawalView = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	
	//trading
	[Const.SET_TRADING_LIST]: (state, data) => {	
		try {
			state.tradingList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_TRADING_ORDERS]: (state, data) => {	
		try {
			state.tradingOrders = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_TRADING_VIEW]: (state, data) => {	
		try {
			state.tradingView = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_TICKET_DATA]: (state, data) => {	
		try {
			state.ticketData = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_WEB_HOOKS]: (state, data) => {	
		try {
			state.webHooks = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_CLIENT_DATA]: (state, data) => {	
		try {
			state.clientData = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_ORDER_HISTORY]: (state, data) => {	
		try {
			state.orderHistory = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_ORDER_HISTORY_SOCIAL_DATA]: (state, data) => {	
		try {
			state.socialOrders= data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
}



// WEBPACK FOOTER //
// ./src/plugins/fxView/provider/candle-history/store-addons/mutations.js